import React from 'react';

const AIMain = () => {
  return (
    <div className="ai-container">
      <h1>The AI Area</h1>
      <p>Welcome to the AI section of the application.</p>
    </div>
  );
};

export default AIMain; 